<template lang="pug">
.main_main_contents
  .page-title
    .title_left
      h2 アカウント設定
  .x_panel
    .x_content
      .action
        button.customsmallbutton.btn.btn-info.add(type='button' @click='add') ユーザ追加
        button.customsmallbutton.btn.btn-info.add(type='button' @click='grid') 再表示
        button.customsmallbutton.btn.btn-success.update(type='button' @click='update') データ更新
      table.table.table-bordered.datatable
        tbody
          tr.active
            th.name 氏名
            th.kana カナ
            th.mail メールアドレス
            th.password パスワード
            th.status 利用状態
            th.admin 管理者権限
            th.operation 操作
          tr(is='row' v-for='(user, index) in users' :data.sync='user' :key='user.id' :index='index' v-on:remove='users.splice(index, 1)' ref='child')
</template>

<script>
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import row from '@/components/dashboard/admin/Accounts_Row'
import qs from 'querystring'
import Message from '@/service/Message'

export default {
  data () {
    return {
      users: []
    }
  },
  created () {
    this.grid()
  },
  methods: {
    grid () {
      Loader.show()
      let axios = Request.instance(true)
      let result = axios.get('/users')
      let vue = this
      vue.users = []
      result.then((res) => {
        vue.users = res.data
        vue.$nextTick(() => { Loader.hide() })
      })
    },
    // 行を追加する
    add () {
      this.users.push({
        id: new Date().getTime(),
        name: '',
        kana: '',
        mail: '',
        password: '',
        use: 1,
        admin: 0, // 管理者権限は基本的には付与できない
        action: 'insert'
      })
    },
    // 全体をupdateする
    update () {
      console.log(this.$refs)
      let errorLine = []
      let children = this.$refs.child
      for (let key in children) {
        console.log(children[key].$v.$invalid)
        if (children[key].$v.$invalid) {
          errorLine.push(Number(key) + 1 + '行目の入力内容に不備があります')
        }
      }
      if (errorLine.length > 0) {
        Message.error(errorLine)
        return
      }
      console.log(this.users)
      Loader.show()
      let axios = Request.instance(true)
      let self = this
      axios.post('/users',
        qs.stringify({
          users: JSON.stringify(this.users)
        })
      ).then((res) => {
        self.grid()
      }).catch((res) => {
        console.log(res)
        this.$nextTick(() => { Loader.hide() })
        // dashboardへメッセージを送信
        Message.success(res.response.data.message)
      })
    }
  },
  components: {
    row: row
  }
}
</script>

<style lang="stylus" scoped>
.action
  width: 100%
  margin-bottom: 10px
  .add
    float: left
  .update
    float: right
.datatable
  .name
    width: 18%
  .kana
    width: 18%
  .mail
    width: 25%
  .password
    width: 15%
  .status
    width: 10%
  .admin
    width: 10%
</style>



// WEBPACK FOOTER //
// Accounts.vue?0662957a